<template>
  <div :class="['view-more-wrapper', customClass]">
    <a :href="link">view more</a>
  </div>
</template>

<script>
export default {
  name: "viewMore",
  inject: ["menuItems"], // App.vueのprovideからmenuItemsを取得
  props: {
    id: {
      type: Number,
      required: true,
    },
    customClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    // セクションに応じたリンクを取得
    sectionData() {
      return this.menuItems.find((item) => item.id === this.id);
    },
    link() {
      return this.sectionData?.link || "/";
    },
  },
};
</script>

<style scoped>
.view-more-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  margin-top: 50px;
  margin-bottom: 100px;
}

.view-more-wrapper a {
  text-decoration: none;
  color: #1b1b1b;
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 600;
  border-bottom: 1px solid;
  border-color: #1b1b1b;
  transition: color 0.2s ease-out;
  padding-bottom: 4px;
  padding-right: 18px;
}

.view-more-wrapper a:hover {
  color: #69b1a9;
  border-color: #69b1a9;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {
  .view-more-wrapper a {
    font-size: 12px;
  }
}
</style>